module.exports = __webpack_public_path__ + "img/рз_40.08a68c16.png";